module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-results-photo-02.jpg?h=74cb4bbc855fd3590c1e89f644540dd8";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-results-photo-02.jpg
// module id = 2107
// module chunks = 12 15